import { render, staticRenderFns } from "./TemplatesBusinessUnit.vue?vue&type=template&id=1679c8e8&scoped=true&"
import script from "./TemplatesBusinessUnit.vue?vue&type=script&lang=js&"
export * from "./TemplatesBusinessUnit.vue?vue&type=script&lang=js&"
import style0 from "./TemplatesBusinessUnit.vue?vue&type=style&index=0&id=1679c8e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1679c8e8",
  null
  
)

export default component.exports